import { BUILDER_API_KEY } from "../shared/env";

export const GET_ALL_CATEGORY =
    `https://cdn.builder.io/api/v1/query/${BUILDER_API_KEY}/category%3A3c5b3b30?omit=meta.componentsUsed&apiKey=${BUILDER_API_KEY}&options.category:3c5b3b30.limit=30&options.category:3c5b3b30.query={%22data.isSeries%22:{%22$eq%22:true}}`;
